import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { NgxToasterService } from '../../../../services/ngx-toaster.service';
import { LocalstorageService } from '../../../../services/localstorage.service';
import { ConfigurationService } from '../../../../services/configuration.service';

import {
  Calendar,
  FbChannel,
  FbForecast,
  ForecastCell,
  Measure,
  UserFbForecast,
  Version,
} from '../../../../common/facebook.models';
import { TreeviewItem } from 'ngx-treeview';
import { USER_ID, USER_INFO } from '../../../../common/keys';
import {
  FB_Template,
  HalfYear,
  Month,
  PhysicalYear,
  Quarter,
  Week,
} from '../global.models';
import { throwError } from 'rxjs';

import { InlineWorker } from './inline-worker';
import { environment } from '../../../../environments/environment';
import { ForecastConfirmationModalComponent } from '../fb-forecast/forecast-confirmation-modal/forecast-confirmation-modal.component';
import { ForecastSavedVersionsComponent } from '../fb-forecast/forecast-saved-versions/forecast-saved-versions.component';
import { ForecastDeletePlannerModalComponent } from '../fb-forecast/fb-forecast-delete-planner-modal/fb-forecast-delete-planner-modal.component';
import { Retail_Direct } from '../../mock-forecast';
import { InventoryPlannerMeasureProfileComponent } from './inventory-planner-measure-profile/inventory-planner-measure-profile.component';
import * as moment from 'moment';
import {
  addCommas,
  CreateAccountScrollingList,
  CreateAccountTree,
  CreateCalendarList,
  CreateCalendarListWithoutWeeks,
  CreateCalendarListWithWeeks,
  CreateItemTree,
  CreateProductScrollingList,
} from 'src/common/functions';

@Component({
  selector: 'app-inventory-planner',
  templateUrl: './inventory-planner.component.html',
  styleUrls: ['./inventory-planner.component.scss'],
})
export class InventoryPlannerComponent implements OnInit {
  @Input() data: any;
  maxPlannerCount = environment.maxPlannerSaveCount;
  public clientId = 1;
  public measureList: Measure[];
  public channelList: FbChannel[];
  public timeframeList: Calendar[];
  public versionList: Version[];
  public fbForecastList: UserFbForecast[];
  public channles = [];
  public customers = [];
  public countries = [];
  public continentList = [];
  public channelDropdownList: TreeviewItem[];
  public calendarListDropdown: TreeviewItem[];
  public leftGroupList = [];
  public productFlatList = [];
  public productList = [];
  public itemIds = [];
  public channelIds = [];
  public calendarIds = [];
  public dropdownObjects;
  public updatedDropdownObject;
  public yearListGrid = [];
  public tempYearListGrid = [];
  public yearList = [];
  public forecastList = [];
  public restoredProductList = [];
  public restoredChannelList = [];
  public restoreCalendarList = [];
  public scenarioPlanningList: Measure[] = [];
  public timeFrameListWithWeeksUPD = [];
  public calendarIdsUDP = [];
  public calendarIdsScenario = [];
  public udpfcstList = [];
  public udpMeasuresList = [];
  public fcstScenarioPlanningList = [];
  public forecastMethodList;
  public seasonalitySourceLevelList;
  public averageWeekList;
  public fbForecast;
  showVersionList = false;
  className = '';
  public hideScreen = true;
  public versionTypeId = 2;
  public userFBForecastId = 0;
  public selectedScenario;
  plannerName = '';
  @ViewChild('saveForecast') saveForecastTemplate: TemplateRef<any>;
  @ViewChild('commitForecast') commitForecast: TemplateRef<any>;
  savedPlanner: {};
  selectedProducts = [];
  productTree = [];
  channelTree = [];
  productTreeNodes = [];
  channelTreeNodes = [];
  isOpenSaved: boolean;
  isBuidlNew: boolean;
  isRestoreSession: boolean;
  gridMapped: boolean;
  channelValue: any = '';
  calanderValue: any = '';
  productValue: any = '';
  isShowTreeDropDowns: boolean;
  public itemsList = [];
  public accountList = [];
  public productSettingList = [];
  public channelSettingList = [];
  public tempForecastList = [];
  public timeFrameListWithWeeks = [];
  public TimeframeWithWeeksUDP = [];
  public TimeframeWithWeeksScenario = [];
  refreshMeasureIds;
  selectedChannelIds = [];
  product: string;
  account: string;
  viewPermission = true;
  editPermission = false;
  readOnlyMeasres: Measure[];
  editViaUploadMeasures: Measure[];
  public forecastMethod;
  public seasonalitySourceLevel;
  public movingAverageWeeks;
  public selectedForecastMeasure;
  public selectedUDPMeasure;
  public adjustment;
  public selectedScenarioForecastMeasure;
  public forecastMethodValue = '';
  public seasonalitySourceLevelValue = '';
  public movingAverageWeeksValue = '';
  public date = new Date();
  public measureKeys = [];
  public invItemIds = [];
  public invChannelIds = [];
  public DefaultMeasures = [
    'ActualST',
    'ActualSTCumulative',
    'UDPLikelyTotalFcst',
    'UDPLikelyTotalFcstCumulative',
    'CustomerSTFcst',
    'CustomerSTFcstCumulative',
    'CPFRSTOverrideFcst',
    'CPFRSellThruOverrideFcstCumulative',
    'CPFRComments',
    'AccountAvailableAllocation',
    'AccountFinalSellInShipped',
    'AccountConstrainedSellInFcstCumulative',
    'CustomerSellInFcst',
    'InTransit',
    'OpenOrders',
    'Shipments',
    'ProjectedDeliveries',
    'DeliveredQty',
    'AccountEndingonHandInventory',
    'AccountConstrainedEndingInventory',
    'AccountConstrainedFWOS',
    'AccountTargetFWOS',
    'CPFRSellThruOverrideFcst',
  ];
  public isDeleted = true;
  public masterMeasureList = [];
  get refreshMeasuresList() {
    return this.masterMeasureList.filter(row => row.isRefresh);
  }
  constructor(
    public spinner: NgxSpinnerService,
    public toastr: NgxToasterService,
    public storage: LocalstorageService,
    public dialogRef: MatDialogRef<any>,
    public ref: MatDialogRef<any>,
    public configurationService: ConfigurationService,
    public dialog: MatDialog
  ) {}
  async ngOnInit() {
    if (this.data) {
      this.data = JSON.parse(this.data);
    }
    let userTeams = this.storage.get(USER_INFO).teams;
    userTeams.forEach((element) => {
      element.teamScreenGroup.forEach((group) => {
        if (group.screenGroupId == 5 && group.viewPermission) {
          this.viewPermission = true;
        }
        if (group.screenGroupId == 5 && group.editPermission) {
          this.editPermission = true;
        }
      });
    });
    this.getUserForecast();
    if (this.showVersionList) {
      this.className = 'col-md-3 form-group';
    } else {
      this.className = 'col-md-3 form-group';
    }
  }
  public getUserForecast = async () => {
    const model = {
      userId: this.storage.get(USER_ID),
      userFBForecastId: 0,
      fbTemplateId: FB_Template.Retail_Direct,
    };
    this.fbForecast = await this.configurationService
      .GetUserSession(model)
      .toPromise()
      .catch((error) => throwError(error));
    if (
      this.fbForecast.itemIds &&
      this.fbForecast.channelIds &&
      this.fbForecast.calendarIds
    ) {
      this.openActionDialog(true);
    } else {
      this.openActionDialog(false);
    }
  };
  public getDefaultDropdowns = async (forecast?: any) => {
    this.configurationService
      .measuresGetList({ FBTemplateId: FB_Template.Retail_Direct })
      .subscribe((res: Measure[]) => {
        this.masterMeasureList = res;
        this.measureList = res.filter(
          (row) => this.DefaultMeasures.includes(row.code) || !row.parentId
        );
        this.readOnlyMeasres = this.measureList.filter(
          (x) => x.templateId == 1
        );
        this.editViaUploadMeasures = this.measureList.filter(
          (x) => x.templateId == 2
        );
        this.extractParentsFromMeasures(forecast);
      });
    const params = {
      offset: 0,
      pageSize: 100000,
      active: true,
    };

    let url = `offSet=${params.offset ? params.offset : 0}&pageSize=${
      params.pageSize ? params.pageSize : 10
    }&active=true`;
    this.configurationService.ItemAccountGetAll(url).subscribe((res) => {
      this.accountList = res.data || [];
      this.accountList = this.accountList.filter(
        (row) => row.partnerType === 'RETAILER DIRECT'
      );
      this.GetAccountSettingList(forecast);
    });
    this.configurationService.ItemManagerGetAll(url).subscribe((res) => {
      this.itemsList = res.data || [];
      this.GetProductSettingList(forecast);
    });
    this.configurationService
      .calendarGetList({})
      .subscribe((res: Calendar[]) => {
        this.timeframeList = res;
        const calendarIds = [];
        let startMonthDate = moment().add(-2, 'M');
        let endMonthDate = moment().add(3, 'M');
        this.timeframeList.forEach((calendar) => {
          const currentMonth = moment(calendar.weekStartDate).month();
          const currentYear = moment(calendar.weekStartDate).year();
          if (
            (startMonthDate.month() <= currentMonth &&
              startMonthDate.year() === currentYear) ||
            (endMonthDate.month() >= currentMonth &&
              endMonthDate.year() === currentYear)
          ) {
            calendarIds.push(calendar.calendarId);
          }
        });
        if (calendarIds.length > 0 && this.isBuidlNew) {
          this.fbForecast.calendarIds = calendarIds.toString();
          this.createCalendarListDropdown(this.fbForecast);
        } else {
          this.createCalendarListDropdown(forecast);
        }
      });
    const params1 = {
      userId: this.storage.get(USER_ID),
      fbTemplateId: FB_Template.Retail_Direct,
    };
    this.configurationService
      .userFBForecastGetList(params1)
      .subscribe((res: UserFbForecast[]) => {
        this.fbForecastList = res;
      });
  };
  public GetProductSettingList = (forecast?: any) => {
    this.configurationService
      .ProductSettingMappingGetList({})
      .subscribe((res) => {
        this.productSettingList = res;
        this.createProductDropdownList(res, forecast);
      });
  };
  public GetAccountSettingList = (forecast?: any) => {
    this.configurationService
      .AccountSettingMappingGetList({})
      .subscribe((res) => {
        this.channelSettingList = res;
        this.createChannelDropdownList(res, forecast);
      });
  };
  public createProductDropdownList = (productSettingList, forecast) => {
    this.productList = CreateItemTree(
      productSettingList,
      this.itemsList,
      forecast
    );
    if (forecast) {
      const itemIds = forecast.itemIds;
      this.mapProductScrollingList(itemIds);
    }
  };
  public mapProductScrollingList = (itemIds) => {
    this.productTree = CreateProductScrollingList(
      itemIds,
      this.itemsList,
      this.productSettingList
    );
    this.productTreeNodes = this.productTree;
    let leafNodes = this.getLeafNodes(this.productTree);
    this.productTree = leafNodes;
  };
  public createChannelDropdownList = (accoutSettingList, forecast) => {
    accoutSettingList = accoutSettingList.filter((account) =>
      this.accountList.find(
        (el) =>
          el.channelId === account.channelId &&
          el.regionId === account.continentId &&
          el.countryId === account.countryId &&
          el.distributorId === account.distributorId
      )
    );
    this.channelDropdownList = CreateAccountTree(
      accoutSettingList,
      this.accountList,
      forecast
    );
    if (forecast && this.channelDropdownList.length > 0) {
      let channelIds = forecast.channelIds;
      this.mapChannelScrollingList(channelIds);
    }
  };
  public mapChannelScrollingList = (channelIds) => {
    this.channelTree = CreateAccountScrollingList(
      channelIds,
      this.accountList,
      this.channelSettingList
    );
    this.channelTreeNodes = this.channelTree;
    let leafNodes = this.getLeafNodes(this.channelTree);
    this.channelTree = leafNodes;
  };
  public createCalendarListDropdown = (forecast?: any) => {
    this.calendarListDropdown = CreateCalendarList(
      this.calendarListDropdown,
      this.timeframeList,
      forecast
    );
  };
  getLeafNodes(nodes, result = []) {
    if (nodes) {
      for (var i = 0, length = nodes.length; i < length; i++) {
        if (!nodes[i].children || nodes[i].children.length === 0) {
          result.push(nodes[i]);
        } else {
          result = this.getLeafNodes(nodes[i].children, result);
        }
      }
      return result;
    }
  }
  public extractParentsFromMeasures = (forecast?: any) => {
    const groupList = this.measureList.filter((measure) => !measure.parentId);
    this.leftGroupList = groupList
      .map((row) => ({
        ...row,
        rowspan: this.measureList.filter(
          (measure) => measure.parentId === row.measureId
        ).length,
      }))
      .sort((a, b) => a.sort - b.sort);
    this.measureList = this.measureList
      .filter((row) => row.parentId)
      .map((row) => ({ ...row, checked: true }))
      .sort((a, b) => a.sort - b.sort);
  };
  openFullScreen = (id: string) => {
    const domGrid = document.getElementById(id) as any;
    if (domGrid) {
      domGrid.webkitRequestFullscreen();
    }
  };

  openActionDialog(restoreSession: boolean): void {
    // tslint:disable-next-line: no-use-before-declare
    const sessionLabel = restoreSession
      ? 'Your last session ended abruptly, would you like to return to where you left off?'
      : 'Would you like to open a saved planner or build new?';
    this.dialog
      .open(ForecastConfirmationModalComponent, {
        width: '848px',
        panelClass: ['fb-dialog-wrapper2', 'fb-dialog-wrapper3'],
        data: {
          isRestoreSession: restoreSession,
          label: sessionLabel,
          isOnLoad: restoreSession ? false : true,
          isSaveAndCommit: false,
        },
        disableClose: true,
      })
      .afterClosed()
      .subscribe((command) => {
        if (command && command.isCanceled) {
          this.closeScreen();
        } else if (command && command.openSaved) {
          this.isOpenSaved = true;
          this.openSavedVersionDialog();
        } else if (command && command.restoreSession) {
          this.restoreSession();
          this.isRestoreSession = true;
          this.hideScreen = false;
        } else {
          this.hideScreen = false;
          this.getDefaultDropdowns();
          this.deleteFbForecast();
          this.isBuidlNew = true;
          this.isShowTreeDropDowns = true;
        }
      });
  }
  public deleteFbForecast() {
    this.isDeleted = false;
    const model = {
      userId: this.storage.get(USER_ID),
      userFBForecastId: 0,
      fbTemplateId: FB_Template.Retail_Direct,
    }
    this.configurationService.fbForecastDefaultDelete(model).subscribe(res => {
      this.isDeleted = true;
    }, error => {
      this.isDeleted = true;
    })
  }
  public openSavedPlanner = async (version) => {
    const model = {
      userId: this.storage.get(USER_ID),
      userFBForecastId: version.userFBForecastId,
      fbTemplateId: FB_Template.Retail_Direct,
    };
    this.userFBForecastId = version.userFBForecastId;
    this.fbForecast = await this.configurationService
      .GetUserSession(model)
      .toPromise()
      .catch((error) => throwError(error));
    this.versionTypeId = 3;
    this.userFBForecastId = version.userFBForecastId;
    this.createChannelDropdownList(this.channelSettingList, this.fbForecast);
    this.createProductDropdownList(this.productSettingList, this.fbForecast);
    this.getDefaultDropdowns(this.fbForecast);
  };
  public restoreSession = async () => {
    this.createChannelDropdownList(this.channelSettingList, this.fbForecast);
    this.createProductDropdownList(this.productSettingList, this.fbForecast);
    this.getDefaultDropdowns(this.fbForecast);
  };
  public openSavedVersionDialog = () => {
    const dialogRef = this.dialog.open(ForecastSavedVersionsComponent, {
      width: '848px',
      panelClass: 'fb-dialog-wrapper2',
      data: { isDirectInventory: true },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res && res.version) {
        this.openSavedPlanner(res.version);
        this.plannerName = res.version.name;
        this.userFBForecastId = res.version.userFBForecastId;
        const model = {
          ...this.data,
          version: res.version,
        };
        this.configurationService.savedPlannerOpened.next(model);
        this.hideScreen = false;
      }
    });
  };
  public openDeletePlannerDialog = () => {
    const dialogRef = this.dialog.open(ForecastDeletePlannerModalComponent, {
      width: '848px',
      panelClass: 'fb-dialog-wrapper2',
      data: {},
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res && res.version) {
        this.openSavedPlanner(res.version);
        this.configurationService.savedPlannerOpened.next(res.version);
        this.hideScreen = false;
      }
    });
  };
  public closeScreen = () => {
    this.configurationService.removeMenu.next(this.data);
  };
  setValue = (selectedDropdown) => {
    switch (selectedDropdown.type) {
      case 'Item': {
        this.itemIds = selectedDropdown.value;
        break;
      }
      case 'Channel': {
        this.channelIds = selectedDropdown.value;
        this.selectedChannelIds = selectedDropdown.value;
        break;
      }
      case 'Timeframe': {
        this.calendarIds = selectedDropdown.value;
        break;
      }
      case 'TimeframeWithWeeksUDP': {
        this.calendarIdsUDP = selectedDropdown.value;
        break;
      }
      case 'TimeframeWithWeeksScenario': {
        this.calendarIdsScenario = selectedDropdown.value;
        break;
      }
    }
    this.channelIds =
      this.channelIds.filter((el) => typeof el === 'number') || [];
    this.itemIds = this.itemIds.filter((el) => typeof el === 'number') || [];
    this.dropdownObjects = {
      itemIds: this.itemIds || [],
      channelIds: this.channelIds,
      calendarIds: this.calendarIds || [],
    };
    this.updatedDropdownObject = this.dropdownObjects;
    if (this.isOpenSaved || this.isRestoreSession) {
      this.mapGridList(true);
    }
  };
  setDataManagerValues(selectedDropdown) {
    switch (selectedDropdown.type) {
      case 'TimeframeWithWeeksUDP': {
        this.calendarIdsUDP = selectedDropdown.value;
        break;
      }
      case 'TimeframeWithWeeksScenario': {
        this.calendarIdsScenario = selectedDropdown.value;
        break;
      }
    }
  }
  setRestoredValue = (selectedDropdown) => {
    switch (selectedDropdown.type) {
      case 'Item': {
        this.itemIds = selectedDropdown.value;
        break;
      }
      case 'Channel': {
        this.channelIds = selectedDropdown.value;
        this.selectedChannelIds = selectedDropdown.value;
        break;
      }
      case 'Timeframe': {
        this.calendarIds = selectedDropdown.value;
        break;
      }
    }
    this.channelIds =
      this.channelIds.filter((el) => typeof el === 'number') || [];
    this.itemIds = this.itemIds.filter((el) => typeof el === 'number') || [];
    this.dropdownObjects = {
      itemIds: this.itemIds || [],
      channelIds: this.channelIds,
      calendarIds: this.calendarIds || [],
    };
  };

  public mapGridList = async (isOnload) => {
    this.product = '';
    this.account = '';
    this.itemIds.forEach((element) => {
      this.product = this.itemsList.find(
        (x) => x.itemManagerId == Number(element)
      )
        ? this.product +
          this.itemsList.find((x) => x.itemManagerId == Number(element))
            .brandName +
          ';'
        : this.product;
    });
    this.channelIds.forEach((element) => {
      this.account = this.accountList.find(
        (x) => x.accountTypeId == Number(element)
      )
        ? this.account +
          this.accountList.find((x) => x.accountTypeId == Number(element))
            .regionName +
          ';'
        : this.account;
    });
    this.gridMapped = true;
    if ((this.isOpenSaved || this.isRestoreSession) && !isOnload) {
      this.isOpenSaved = false;
      this.isRestoreSession = false;
    }
    this.spinner.show();
    if (this.isBuidlNew && this.isShowTreeDropDowns) {
      if (
        this.fbForecast &&
        this.fbForecast.itemIds &&
        this.fbForecast.itemIds.match(/^[a-z0-9]+$/i)
      ) {
        this.fbForecast.itemIds = this.itemIds;
      }
      this.isShowTreeDropDowns = false;
    }
    this.mapChannelScrollingList(this.channelIds.toString());
    this.mapProductScrollingList(this.itemIds.toString());
    this.forecastList = [];
    this.createGridList();
  };
  public createGridList = async (event?) => {
    if (event && event.itemIds && event.channelIds) {
      this.forecastList = [];
      event.isScrolling = true;
      this.traverseSelectedOptions(event);
    } else {
      if (
        this.dropdownObjects.itemIds.length &&
        this.dropdownObjects.channelIds.length &&
        this.dropdownObjects.calendarIds.length
      ) {
        this.traverseSelectedOptions(this.dropdownObjects);
      }
    }
  };
  public traverseSelectedOptions = (event) => {
    const calendarIds = [];
    if (event.calendarIds) {
      event.calendarIds.flat().forEach((calendar) => {
        calendarIds.push(calendar);
      });
    }
    let leafNodesProduct = this.getLeafNodes(this.productTree);
    let leafNodesChannel = this.getLeafNodes(this.channelTree);
    leafNodesProduct = leafNodesProduct.sort((a, b) =>
      a.text > b.text ? 1 : -1
    );
    leafNodesChannel = leafNodesChannel.sort((a, b) =>
      a.text > b.text ? 1 : -1
    );
    const selectedChannel = leafNodesChannel[0];
    const channelId = selectedChannel ? selectedChannel.value : '';
    const selectedProduct = leafNodesProduct[0];
    const itemId = selectedProduct ? selectedProduct.value : '';
    event.calendarIds = calendarIds;
    this.invItemIds =
      event.itemIds.length === 1 ? event.itemIds.toString() : itemId.toString();
    this.invChannelIds =
      event.channelIds.length === 1
        ? event.channelIds.toString()
        : channelId.toString();
    if (this.isRestoreSession || this.isOpenSaved) {
      const model = {
        userId: this.storage.get(USER_ID),
        userFBForecastId: this.userFBForecastId || 0,
        fbTemplateId: FB_Template.Retail_Direct,
        RestoreSession: true,
        VersionTypeId: this.versionTypeId,
        itemIds:
          event.itemIds.length === 1
            ? event.itemIds.toString()
            : itemId.toString(),
        channelIds:
          event.channelIds.length === 1
            ? event.channelIds.toString()
            : channelId.toString(),
        invItemIds:
          event.itemIds.length === 1
            ? event.itemIds.toString()
            : itemId.toString(),
        invChannelIds:
          event.channelIds.length === 1
            ? event.channelIds.toString()
            : channelId.toString(),
        calendarIds: event.calendarIds.flat().toString(),
      };
      this.configurationService
        .fbForecastGetPerformance(model)
        .subscribe((res) => {
          this.fbForecast = res;
          this.mapWeeksList();
          this.spinner.hide();
        });
    } else {
      const getModel = {
        userId: this.storage.get(USER_ID),
        userFBForecastId: this.userFBForecastId || 0,
        fbTemplateId: FB_Template.Retail_Direct,
        VersionTypeId: this.versionTypeId,
        itemIds: event.itemIds.toString(),
        channelIds: event.channelIds.toString(),
        invItemIds: itemId.toString(),
        invChannelIds: channelId.toString(),
        calendarIds: event.calendarIds.flat().toString(),
      };
      const addModel = {
        userId: this.storage.get(USER_ID),
        userFBForecastId: this.userFBForecastId || 0,
        fbTemplateId: FB_Template.Retail_Direct,
        VersionTypeId: this.versionTypeId,
        itemIds: event.itemIds.toString(),
        channelIds: event.channelIds.toString(),
        invItemIds: itemId.toString(),
        invChannelIds: channelId.toString(),
        calendarIds: event.calendarIds.flat().toString(),
      };
      this.configurationService
        .FbForecastDefaultAdd(addModel)
        .subscribe((res) => {});
      this.spinner.show();
      this.configurationService
        .fbForecastGetPerformance(getModel)
        .subscribe((res) => {
          this.fbForecast = res;
          this.mapWeeksList();
          this.spinner.hide();
        });
    }
  };
  public mapWeeksList() {
    this.yearListGrid = new Array();
    this.yearListGrid = this.fbForecast.weeks.map((row) => {
      Object.keys(row['measures']).forEach((measure) => {
        const measures = ['AccountConstrainedFWOS', 'AccountTargetFWOS'];
        if (measures.includes(measure)) {
          row['measures'][measure] = Number(
            Number(row['measures'][measure]).toFixed(2)
          );
        } else if (measure.indexOf('Comment') < 0) {
          if (measure.endsWith('Pct')) {
            if (!row['measures'][measure].endsWith('%')) {
              row['measures'][measure] = Math.round(Number(row['measures'][measure]));
              row['measures'][measure] =  row['measures'][measure] + '%';
            }
          } else {
            row['measures'][measure] = Math.round(
              Number(row['measures'][measure])
            );
          }
        }
        row['measures'][measure] = addCommas(row['measures'], measure);
      });
      this.measureKeys = Object.keys(row['measures']);
      return {
        ...row,
        title: new Date(row.weekStartDate).toLocaleDateString(),
      };
    });
    this.tempYearListGrid = this.yearListGrid;
    this.createCalendarListDropdownWithWeeks(this.fbForecast);
    this.restoredProductList = [...this.productTreeNodes];
    this.restoredChannelList = [...this.channelTreeNodes];
  }
  openMesuresDialog() {
    this.dialog
      .open(InventoryPlannerMeasureProfileComponent, {
        width: '1200px',
        panelClass: 'fb-dialog-wrapper',
        data: { measureList: this.measureList },
      })
      .afterClosed()
      .subscribe((command) => {
        if (command) {
          console.log(command);
        }
      });
  }
  adjustData() {
    this.dialog
      .open(ForecastConfirmationModalComponent, {
        width: '848px',
        panelClass: 'fb-dialog-wrapper2',
        data: {
          label:
            'Would you like to save your current forecast planner before adjusting?',
          adjustData: true,
        },
        disableClose: true,
      })
      .afterClosed()
      .subscribe((command) => {
        if (command) {
          if (command.isSave) {
            this.forecastList = [];
            this.createGridList();
          }
        }
      });
  }
  save() {
    this.dialog
      .open(ForecastConfirmationModalComponent, {
        width: '848px',
        panelClass: ['fb-dialog-wrapper2', 'fb-dialog-wrapper3'],
        data: {
          label: 'How would you like to proceed?',
          isOnLoad: false,
          isSaveAndCommit: true,
        },
        disableClose: true,
      })
      .afterClosed()
      .subscribe((command) => {
        if (command) {
          if (command.isSave) {
            if (!this.isBuidlNew && !this.isRestoreSession) {
              const model = {
                itemIds: this.itemIds.toString(),
                channelIds: this.channelIds.toString(),
                calendarIds: this.calendarIds.toString(),
                userId: this.storage.get(USER_ID),
                name: this.plannerName,
                fbTemplateId: FB_Template.Retail_Direct,
                userFBForecastId: this.userFBForecastId,
                active: true,
              };
              this.spinner.show();
              this.configurationService
                .userFBForecastUpdate(model)
                .subscribe((resp) => {
                  this.spinner.hide();
                });
            } else {
              const params = {
                userId: this.storage.get(USER_ID),
                fbTemplateId: FB_Template.Retail_Direct,
              };
              this.configurationService
                .userFBForecastGetList(params)
                .subscribe((res) => {
                  if (res.length >= this.maxPlannerCount) {
                    this.dialog
                      .open(ForecastDeletePlannerModalComponent, {
                        width: '848px',
                        panelClass: 'fb-dialog-wrapper2',
                        data: { versionList: res, isDirectInventory: true },
                        disableClose: true,
                      })
                      .afterClosed()
                      .subscribe((command) => {
                        if (command && command.version) {
                          let versions = command.version;
                          this.dialog
                            .open(ForecastConfirmationModalComponent, {
                              width: '848px',
                              panelClass: 'fb-dialog-wrapper2',
                              data: {
                                label:
                                  'Are you sure you want to delete this planner?',
                                isOnLoad: false,
                                isDeletePlanner: true,
                              },
                              disableClose: true,
                            })
                            .afterClosed()
                            .subscribe((command) => {
                              if (command.isDelete) {
                                let model = {
                                  versionTypeId: null,
                                  userFBForecastIds: '',
                                  fbTemplateId: FB_Template.Retail_Direct,
                                };
                                model.versionTypeId = 3;
                                for (var i = 0; i < versions.length; i++) {
                                  model.userFBForecastIds =
                                    model.userFBForecastIds +
                                    versions[i].userFBForecastId +
                                    ',';
                                }
                                model.userFBForecastIds =
                                  model.userFBForecastIds.slice(0, -1);
                                this.configurationService
                                  .userFBForecastDeleteByVersionID(model)
                                  .subscribe((resp) => {
                                    this.saveForecast();
                                  });
                              }
                            });
                        }
                      });
                  } else {
                    this.saveForecast();
                  }
                });
            }
          } else if (command.isCommit) {
            this.commitForecastPlanner();
          } else if (command.isSaveCommit) {
            this.saveForecast(command.isSaveCommit);
          }

          //
        }
      });
  }
  public saveForecast = (saveCommit?) => {
    if (saveCommit && this.userFBForecastId) {
      const model = {
        itemIds: this.itemIds.toString(),
        channelIds: this.channelIds.toString(),
        calendarIds: this.calendarIds.toString(),
        userId: this.storage.get(USER_ID),
        name: this.plannerName,
        fbTemplateId: FB_Template.Retail_Direct,
        userFBForecastId: this.userFBForecastId,
        active: true,
      };
      this.spinner.show();
      this.configurationService
        .userFBForecastUpdate(model)
        .subscribe((resp) => {
          this.spinner.hide();
          this.commitForecastPlanner();
        });
    } else {
      this.dialog
        .open(ForecastConfirmationModalComponent, {
          width: '848px',
          panelClass: 'fb-dialog-wrapper2',
          data: {
            label: 'What would you like to name your planner?',
            isOnLoad: false,
            changeNameConfirmation: true,
            isInputRequired: true,
            inputLabel: 'Enter name',
          },
          disableClose: true,
        })
        .afterClosed()
        .subscribe((command) => {
          if (command) {
            this.plannerName = command.name;
            this.savePlanner(saveCommit);
          }
        });
    }
  };
  public savePlanner = (saveCommit?) => {
    const params = {
      userId: this.storage.get(USER_ID),
      fbTemplateId: FB_Template.Retail_Direct,
    };
    this.configurationService.userFBForecastGetList(params).subscribe((res) => {
      if (res.find((x) => x.name == this.plannerName)) {
        this.dialog.open(ForecastConfirmationModalComponent, {
          width: '848px',
          panelClass: 'fb-dialog-wrapper2',
          data: {
            label:
              'Planner with this name already exists. Please update name and try again',
            isOnLoad: false,
            confirmation: true,
          },
          disableClose: true,
        });
      } else {
        const model = {
          itemIds: this.itemIds.toString(),
          channelIds: this.channelIds.toString(),
          calendarIds: this.calendarIds.toString(),
          userId: this.storage.get(USER_ID),
          name: this.plannerName,
          forecastMethodId: 38,
          seasonalitySourceLevelId: 8,
          movingAverageWeeksId: 20,
          fbTemplateId: FB_Template.Retail_Direct,
          active: true,
          versionTypeId: this.versionTypeId,
        };
        this.spinner.show();
        this.configurationService.userFBForecastAdd(model).subscribe((res) => {
          this.savedPlanner = model;
          this.spinner.hide();
          this.versionTypeId = 3;
          this.userFBForecastId = res;
          this.isOpenSaved = true;
          this.isRestoreSession = false;
          this.isBuidlNew = false;
          const version = {
            ...this.data,
            version: model,
          };
          this.configurationService.savedPlannerOpened.next(version);
          if (saveCommit) {
            this.commitForecastPlanner();
          }
        });
      }
    });
  };
  public commitForecastPlanner = () => {
    this.ref = this.dialog.open(this.commitForecast, {
      width: '848px',
      panelClass: 'fb-dialog-wrapper2',
    });
  };
  public commitFacebookPlanner = () => {
    const model = {
      itemIds: this.itemIds.toString(),
      channelIds: this.channelIds.toString(),
      calendarIds: this.calendarIds.toString(),
      userId: this.storage.get(USER_ID),
      fbTemplateId: FB_Template.Retail_Direct,
      forecastMethodId: 38,
      seasonalitySourceLevelId: 8,
      movingAverageWeeksId: 20,
      userFBForecastId: this.userFBForecastId || 0,
    };
    this.spinner.show();
    this.configurationService.FBForecastCommit(model).subscribe((res) => {
      this.spinner.hide();
      this.ref.close();
      this.dialog.open(ForecastConfirmationModalComponent, {
        width: '686px',
        panelClass: ['fb-dialog-wrapper2', 'fb-dialog-wrapper4'],
        data: {
          label: 'Congratulations! You have successfully committed!',
          isOnLoad: false,
          goBack: true,
        },
        disableClose: true,
      });
    });
  };
  checkIfMaxCountReached() {
    if (!this.isBuidlNew && !this.isRestoreSession) {
      this.save();
      return;
    }

    const params = {
      userId: this.storage.get(USER_ID),
      fbTemplateId: FB_Template.Retail_Direct,
    };
    this.configurationService.userFBForecastGetList(params).subscribe((res) => {
      if (res.length >= this.maxPlannerCount) {
        this.dialog
          .open(ForecastDeletePlannerModalComponent, {
            width: '848px',

            data: { versionList: res, isDirectInventory: true },
            disableClose: true,
          })
          .afterClosed()
          .subscribe((command) => {
            if (command && command.version) {
              let model = {
                versionTypeId: null,
                userFBForecastIds: '',
                fbTemplateId: FB_Template.Retail_Direct,
              };
              model.versionTypeId = 3;
              for (var i = 0; i < command.version.length; i++) {
                model.userFBForecastIds =
                  model.userFBForecastIds +
                  command.version[i].userFBForecastId +
                  ',';
              }
              model.userFBForecastIds = model.userFBForecastIds.slice(0, -1);
              this.configurationService
                .userFBForecastDeleteByVersionID(model)
                .subscribe((resp) => {});
              this.save();
            }
          });
      } else {
        this.save();
      }
    });
  }
  onSelectionChanged(event) {
    if (event.value.includes(-1) > 0) {
      this.refreshMeasureIds = '';
    } else {
      this.refreshMeasureIds = event.value;
    }
  }
  isAnyOpened = () => {
    return document.getElementsByClassName('dropdown show').length > 0;
  };
  FBForecastSelectedUpdateByDropDownType = (type, value) => {
    let model;
    model = {
      fbForecastSelectedId: this.fbForecast.fbForecastSelectedId,
      updateDropDownType: type,
      UserId: this.storage.get(USER_ID),
      FBTemplateId: FB_Template.Retail_Direct,
    };
    if (type === 'ForecastMethod') {
      model.ForecastMethodId = value.commonCodeValueId;
    } else if (type === 'SeasonalitySourceLevel') {
      model.SeasonalitySourceLevelId = value.commonCodeValueId;
    } else if (type === 'MovingAverageWeeks') {
      model.MovingAverageWeeksId = value.commonCodeValueId;
    }
    this.configurationService
      .FBForecastSelectedUpdateByDropDownType(model)
      .subscribe(
        (res) => {},
        (error) => {
          this.spinner.hide();
        }
      );
  };
  updateCriteria(event) {
    this.updatedDropdownObject = event;
    if (event.isSessionUpdate && !this.userFBForecastId) {
      this.isRestoreSession = true;
    } else if (event.isSessionUpdate && this.userFBForecastId) {
      this.isRestoreSession = false;
      this.isOpenSaved = true;
    }
    this.spinner.show();
    this.traverseSelectedOptions(event);
  }
  refreshMeasure() {
    this.dialog
      .open(ForecastConfirmationModalComponent, {
        width: '848px',
        panelClass: 'fb-dialog-wrapper2',
        data: {
          label:
            'Are you sure you want to refresh these measures? Your current data will be lost.',
          isOnLoad: false,
          refreshMeasure: true,
        },
        disableClose: true,
      })
      .afterClosed()
      .subscribe((command) => {
        if (command) {
          this.refreshForecastMeasures();
        }
      });
  }
  public refreshForecastMeasures = () => {
    const model = {
      itemIds: this.dropdownObjects.itemIds.toString(),
      channelIds: this.dropdownObjects.channelIds.toString(),
      calendarIds: this.dropdownObjects.calendarIds.toString(),
      userId: this.storage.get(USER_ID),
      measureIds: this.refreshMeasureIds.toString(),
      userFBForecastId: this.userFBForecastId,
      fbTemplateId: FB_Template.Retail_Direct,
      versionTypeId: this.versionTypeId,
      fbForecastSelectedId: this.fbForecast ? this.fbForecast.fbForecastSelectedId: '',
    };
      this.spinner.show();
    this.configurationService
      .DefaultAddRefresh(model)
      .subscribe((res) => {
        this.traverseSelectedOptions(this.updatedDropdownObject);

      }, error => {
        this.spinner.hide();
      });
  };
  public createCalendarListDropdownWithWeeks = (forecast?: any) => {
    const _timeframeList = this.timeframeList.filter((item) =>
      (forecast.calendarIds as string).includes(item.calendarId.toString())
    );
    const calendarWithoutWeeks = CreateCalendarListWithoutWeeks(
      _timeframeList,
      this.timeFrameListWithWeeks,
      forecast
    );
    this.restoreCalendarList = calendarWithoutWeeks;
  };
}
